import type { SerializedEditorState } from 'lexical';

export const TGPE_CLIPBOARD_MIME = 'web application/x-lexical-tgpe+json';
export const EDITOR_STATE_SCHEMA_VERSION = '1.0';
export const LEXICAL_VERSION = '0.40';

export type ClipboardSource = 'desktop' | 'miniapp';

export interface TGPEClipboardPayload {
  tgpe_version: string;
  lexical_version: string;
  created_at: string;
  source_client: ClipboardSource;
  state: SerializedEditorState;
}

export function isClipboardPayload(value: unknown): value is TGPEClipboardPayload {
  if (typeof value !== 'object' || value === null) return false;
  const v = value as Record<string, unknown>;
  return (
    typeof v.tgpe_version === 'string' &&
    typeof v.lexical_version === 'string' &&
    typeof v.created_at === 'string' &&
    (v.source_client === 'desktop' || v.source_client === 'miniapp') &&
    typeof v.state === 'object' &&
    v.state !== null
  );
}
